import { hasFunctionalConsent } from "@/lib/consent/consent";
import { isAppContext } from "@/lib/appContext";

const KEY = "fs_first_touch";

export interface FirstTouch {
  landing_page: string;
  utm_source: string | null;
  utm_medium: string | null;
  utm_campaign: string | null;
  referrer: string | null;
  captured_at: string;
}

/** Capture entry context once per session. First write wins; later calls no-op. */
export function captureFirstTouch(): void {
  if (typeof window === "undefined") return;
  // FIV-499: attribution is device storage for marketing measurement — it
  // requires Functional consent. Called again by the consent loader on grant.
  if (!hasFunctionalConsent()) return;
  try {
    if (window.sessionStorage.getItem(KEY)) return;
    const p = new URLSearchParams(window.location.search);
    const ft: FirstTouch = {
      landing_page: window.location.pathname,
      utm_source: p.get("utm_source"),
      utm_medium: p.get("utm_medium"),
      utm_campaign: p.get("utm_campaign"),
      referrer: document.referrer || null,
      captured_at: new Date().toISOString(),
    };
    window.sessionStorage.setItem(KEY, JSON.stringify(ft));
  } catch {
    // sessionStorage unavailable (private mode / blocked) — attribution is best-effort.
  }
}

export function getFirstTouch(): FirstTouch | null {
  if (isAppContext()) return null;
  if (typeof window === "undefined") return null;
  try {
    const raw = window.sessionStorage.getItem(KEY);
    return raw ? (JSON.parse(raw) as FirstTouch) : null;
  } catch {
    return null;
  }
}
